export const SERVER_DOMAIN = "https://backend.doctoreteam.ir";
//export const SERVER_DOMAIN = "http://localhost:8001";


export const CLARITY_PROJECT_ID = 'u64azx9sa3';
